import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { Select } from 'antd'
// import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const { Option } = Select

const BARANGAY_CONSTITUENTS = gql`
    query allBarangayConstituents($barangay_uid: String, $searchFilter: SearchParams) {
		allBarangayConstituents(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const Constituent = (props) => {
	const { 
		client, barangay_uid,
		onSelectedItem, onChange, ...rest 
	} = props
	const [searchText, setSearchText] = useState('')

	return (
		<Query 
			query={BARANGAY_CONSTITUENTS}
			variables={{
				barangay_uid,
				searchFilter: { page: 1, pageSize: 500, searchText }
			}}
			fetchPolicy='network-only'
		>
			{({ loading, error, data }) => {
				const constituents = _.has(data, 'allBarangayConstituents') ? data.allBarangayConstituents.data : []
				//console.log('purok', purok)
				return (
					<Select 
						loading={loading}
						allowClear
						showSearch
						placeholder='Select Constituent'
						onSearch={(value) => setSearchText(value)}
						notFoundContent={null}
						showArrow={false}
						filterOption={false}
						onChange={(value) => {
							if (onSelectedItem) {
								const mConstituent = _.find(constituents, (i) => _.isEqual(i.uid, value))
								onSelectedItem(mConstituent)
							}
							onChange(value)
						}}
						{ ...rest }
					>
						{
							constituents.map((item, key) => (
								<Option key={key} value={item.uid}>
									{`${item.first_name} ${item.middle_name || ''} ${item.last_name} ${item.purok_name ? ' - ' + item.purok_name : ''}`}
								</Option>
							))
						}
					</Select>
				)
			}}
		</Query>
	)
}

const composed = compose(
	withApollo
)

export default composed(Constituent)